import listActions from 'src/modules/dataStudio/list/dataStudioListActions';
import DataStudioService from 'src/modules/dataStudio/dataStudioService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'DATASTUDIO_DESTROY';

const dataStudioDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: dataStudioDestroyActions.DESTROY_STARTED,
      });

      await DataStudioService.destroyAll([id]);

      dispatch({
        type: dataStudioDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.dataStudio.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/data-studio');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: dataStudioDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: dataStudioDestroyActions.DESTROY_ALL_STARTED,
      });

      await DataStudioService.destroyAll(ids);

      dispatch({
        type: dataStudioDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.dataStudio.destroyAll.success'),
      );

      getHistory().push('/data-studio');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: dataStudioDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default dataStudioDestroyActions;
